import React from "react";
import ThreadItem from './ThreadItem.js';
import ThreadLast from './ThreadLast.js';


const Thread = (props) => {
  if (props.didMount !== true) {
    return null;
  }

  const arrComponents = [];
  const arrEvents = props.selectedThread.appEvents;
  for (let i = 0; i < arrEvents.length; i++) {
    const element = arrEvents[i];
    // for the last item (or only item) use rich layout
    if (i === (arrEvents.length -1)) {
      arrComponents.push(
        <ThreadLast
            key={element._source.exaId}
            threadItem={element}
            showEditReply={props.showEditReply}
            clicked={props.clicked}
          />
      );
    } else {
      arrComponents.push(
        <ThreadItem
            key={element._source.exaId}
            threadItem={element}
          />
      );
    }
  }
  return arrComponents;
}


export default Thread;



// WEBPACK FOOTER //
// ./src/containers/Timeline/Thread.js